import { DatePicker, Layout, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Color } from '../../Common/Color'
import SlotFilter from './SlotFilter'
import dayjs from 'dayjs'
import consumer from '../../Common/cable'
import SlotsTab from './SlotsTab'
import GlobalContext from '../GlobalContext'

export default function SlotsPage () {
  const { slots, boxes, slotsDate, slotsLoading, fetchSlots, updateSlots, updateBoxes } = useContext(GlobalContext)
  const [slot, setSlot] = useState({})
  const [box, setBox] = useState({})
  const params = new URLSearchParams(location.search)
  const day = params.get('day')
  const [date, setDate] = useState(day ? dayjs(day) : slotsDate)
  const [filter, setFilter] = useState({ name: '', box: '', phone: '', assigned_short_name: '' })
  const [_, setTime] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    fetchSlots(date)
    componentDidMount()
  }, [date])

  useEffect(() => {
    updateBoxes(box)
  }, [box])

  useEffect(() => {
    updateSlots(slot)
  }, [slot])

  const componentDidMount = () => {
    consumer.subscriptions.create({ channel: 'BoxesChannel' }, {
      connected: () => {},
      disconnected: () => { },
      received: (data) => { setBox(data.box) }
    })
    consumer.subscriptions.create({ channel: 'SlotsChannel' }, {
      connected: () => {},
      disconnected: () => { },
      received: (data) => { setSlot(data.slot) }
    })
  }

  const update = (value) => {
    setDate(value)
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const filteredSlots = slots.filter((slot) => {
    const assignedShortName = slot.assigned_short_name ? slot.assigned_short_name.toLowerCase() : ''
    return slot.box.name.toLowerCase().includes(filter.box.toLowerCase()) &&
      slot.name.toLowerCase().includes(filter.name.toLowerCase()) &&
      slot.phone.includes(filter.phone) &&
      assignedShortName.includes(filter.assigned_short_name.toLowerCase())
  })

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{filteredSlots.length}</b> {t('Admin.SlotsPage.title')}</div>
          <SlotFilter filter={filter} onChangeFilter={onChangeFilter} />
        </div>
      </Layout>
      <Layout style={{ flexDirection: 'row', display: 'flex', margin: 'auto', width: '150px' }}>
        <LeftOutlined onClick={() => setDate(date.add(-1, 'day'))} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
        <DatePicker value={date} onChange={update} format={'DD/MM/YYYY'} allowClear={false} />
        <RightOutlined onClick={() => setDate(date.add(1, 'day'))} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
      </Layout>
      <Spin spinning={slotsLoading}>
        <SlotsTab slots={filteredSlots} boxes={boxes} updateSlots={updateSlots} setLoading={() => {}} />
      </Spin>
    </Layout>

  )
}
